import BrandInfo from './components/BrandInfo';
import withRouter from 'react-router-dom/withRouter';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import get from 'lodash/get';
import values from 'lodash/values';

import {
  updateBrand,
  loadBrand,
  createBrand,
  loadAgencies,
  loadRetailers,
  setRetailersForBrand
} from '../../shared/redux/entities/actions'

import {
  alphabeticallySort
} from '../../shared/utils';

function getRetailersForBrand(state,brandId){
  return values(state.entities.companies)
    .filter((c) => !c.isBrand)
    .filter((r) => (r.approvedBrandIds || []).indexOf(brandId) >= 0)
    .map((r) => r.id);
}

function getRetailers(state){
  return values(state.entities.companies)
    .filter((c) => !c.isBrand && c.name && c.name.length > 0)
    .filter((r) => r.name && r.name.length > 0)
    .sort((a,b) => alphabeticallySort(a.name,b.name))
}

function mapStateToProps(state,props){
  const brandId = props.brandId,
    accountId = props.match.params.accountId,
    isCreate = props.match.url.indexOf('new') >= 0;

  return {
    isCreate:isCreate,
    accountId:accountId,
    brandId:brandId,
    name:get(state,['entities','companies',brandId,'name']),
    logoURL:get(state,['entities','companies',brandId,'logoURL']),
    logoFileName:get(state,['entities','companies',brandId,'logoFileName']),
    primaryColor:get(state,['entities','companies',brandId,'primaryColor']),
    agencies:values(state.entities.agencies).filter((a) => a.name),
    retailers:getRetailers(state),
    currentApprovedRetailers:getRetailersForBrand(state,brandId)
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    loadBrand,
    updateBrand,
    createBrand,
    loadAgencies,
    loadRetailers,
    setRetailersForBrand
  },dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(BrandInfo));



// WEBPACK FOOTER //
// ./src/routes/BrandInfo/index.js